var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        display: "flex",
        "flex-direction": "row",
        "overflow-x": "auto",
        "white-space": "nowrap",
        margin: "10px 0",
      },
    },
    _vm._l(_vm.goods, function (item) {
      return _c(
        "div",
        {
          key: item.rgoods,
          staticStyle: {
            flex: "0 0 auto",
            padding: "10px",
            "margin-right": "10px",
            "text-align": "center",
            border: "1px solid #f5f7fa",
            "border-radius": "8px",
            cursor: "pointer",
          },
          on: {
            click: function ($event) {
              return _vm.handleAdd(item)
            },
          },
        },
        [
          _c("el-image", {
            staticStyle: { width: "50px", height: "50px" },
            attrs: { src: item.cmasterUrl, fit: "fit" },
          }),
          _c("p", [_vm._v(_vm._s(item.cremark))]),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }